import Header from './components/common/Header';
import Hero from './components/common/Hero';
import Footer from './components/common/Footer';
import Menu from './components/Menu/Menu';
import './tailwind.css';
import './premium.css';

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <Hero />
      <main className="flex-grow">
        <Menu />
      </main>
      <Footer />
    </div>
  );
}

export default App;